namespace $ {

	export type $shm_hitalama_map_widget_entity_app_files = Record< string, Blob >
	export type $shm_hitalama_map_widget_entity_app_file_meta = {
		readonly name: string
		readonly type: string
		readonly size: number
	}

	export class $shm_hitalama_map_widget_entity_app extends $giper_baza_entity.with({

		Widget: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ),
		Files_meta: $giper_baza_atom_dict,

	}) {

		static archive_name_pattern = /\.app\.zip$/i

		static archive( file: $shm_hitalama_file ) {
			return this.archive_name_pattern.test( file.title() )
		}

		static fflate() {
			return $mol_import.module( 'https://esm.sh/fflate@0.8.2' ) as any
		}

		static blob_type( name: string ) {
			if( /\.m?js$/i.test( name ) ) return 'text/javascript'
			if( /\.css$/i.test( name ) ) return 'text/css'
			if( /\.html?$/i.test( name ) ) return 'text/html'
			if( /\.json$/i.test( name ) ) return 'application/json'
			if( /\.svg$/i.test( name ) ) return 'image/svg+xml'
			return ''
		}

		static files_from( file: $shm_hitalama_file ): $shm_hitalama_map_widget_entity_app_files {
			const blob = file.blob()
			if( !blob ) throw new Error( 'Файл не найден' )

			const buffer = $mol_wire_sync( blob ).arrayBuffer()
			const zipped = this.fflate().unzipSync( new Uint8Array( buffer ) ) as Record< string, Uint8Array >

			return Object.fromEntries(
				Object.entries( zipped )
					.filter( ([ name ])=> !name.endsWith( '/' ) )
					.map( ([ name, bytes ])=> [
						name,
						new Blob( [ bytes.slice() ], { type: this.blob_type( name ) } ),
					] )
			)
		}

		static js_name_from( files: $shm_hitalama_map_widget_entity_app_files ) {
			const names = Object.keys( files ).filter( name => /\.m?js$/i.test( name ) )
			const priorities = [
				'embed.js',
				'web.js',
				'index.js',
				'app.js',
			]

			return priorities.flatMap( priority =>
				names.filter( name => name.split( '/' ).at( -1 ) === priority )
			)[0] ?? names[0] ?? ''
		}

		static js_file_from( file: $shm_hitalama_file ) {
			const files = this.files_from( file )
			const name = this.js_name_from( files )
			if( !name ) throw new Error( `В архиве "${ file.title() }" не найден JS файл` )
			return files[ name ]
		}

		widget( next?: null | $shm_hitalama_map_widget ) {
			return this.Widget( next )?.remote( next ) ?? null
		}

		file() {
			return this.widget()?.File()?.remote() ?? null
		}

		files_meta( next?: Record< string, $shm_hitalama_map_widget_entity_app_file_meta > ) {
			return this.Files_meta( next )?.val( next ) ?? {}
		}

		file_opfs_name( name: string ) {
			return `${ this.link().toString() }_${ encodeURIComponent( name ) }`
		}

		@ $mol_action
		file_write_to_opfs( name: string, file: Blob ) {
			$mol_wire_sync( $shm_hitalama_file ).writeFileToOPFS( file, this.file_opfs_name( name ) )
			return file
		}

		file_read_from_opfs( name: string, type: string ) {
			const file = $mol_wire_sync( $shm_hitalama_file ).readFileFromOPFS( this.file_opfs_name( name ) )
			if( type && file.type !== type ) return new Blob( [ file ], { type } )
			return file
		}

		@ $mol_action
		files_write_to_opfs( files: $shm_hitalama_map_widget_entity_app_files ) {
			const meta = {} as Record< string, $shm_hitalama_map_widget_entity_app_file_meta >

			for( const [ name, file ] of Object.entries( files ) ) {
				this.file_write_to_opfs( name, file )
				meta[ name ] = {
					name,
					type: file.type,
					size: file.size,
				}
			}

			this.files_meta( meta )
			return files
		}

		files_read_from_opfs() {
			const meta = this.files_meta() as Record< string, $shm_hitalama_map_widget_entity_app_file_meta >
			const entries = Object.values( meta )
			if( !entries.length ) return null

			const files = {} as $shm_hitalama_map_widget_entity_app_files
			for( const item of entries ) {
				const file = this.file_read_from_opfs( item.name, item.type )
				if( item.size > 0 && file.size !== item.size ) return null
				files[ item.name ] = file
			}

			return files
		}

		@ $mol_mem
		files() {
			const file = this.file()
			if( !file ) return {} as $shm_hitalama_map_widget_entity_app_files

			try {
				const files = this.files_read_from_opfs()
				if( files ) return files
			} catch( error ) {
				if( $mol_promise_like( error ) ) throw error
			}

			return this.files_write_to_opfs( $shm_hitalama_map_widget_entity_app.files_from( file ) )
		}

		js_name() {
			const name = $shm_hitalama_map_widget_entity_app.js_name_from( this.files() )
			if( !name ) throw new Error( `В архиве "${ this.file()?.title() ?? '' }" не найден JS файл` )
			return name
		}

		js_file() {
			return this.files()[ this.js_name() ]
		}

		@ $mol_mem_key
		file_uri( name: string ) {
			const file = this.files()[ name ]
			if( !file ) throw new Error( `В архиве "${ this.file()?.title() ?? '' }" не найден файл "${ name }"` )
			return URL.createObjectURL( file )
		}

		import_module() {
			return $mol_import.module( this.file_uri( this.js_name() ) )
		}

	}

}
